"use client";

import Link from "next/link";
import PropTypes from "prop-types";

const Logo = ({ 
  logoUrl, 
  logoAlt = "Logo", 
  scrolled = false, 
  href = "/", 
  className = "",
  showHoverEffect = true,
  customSizes
}) => {
  if (!logoUrl) return null;

  const defaultScrolledSizes = "h-8 sm:h-10 md:h-11 lg:h-12 xl:h-14";
  const defaultNormalSizes = "h-10 sm:h-12 md:h-14 lg:h-16 xl:h-18";
  
  const logoSizes = customSizes || (scrolled ? defaultScrolledSizes : defaultNormalSizes);

  return (
    <Link href={href} className={`flex-shrink-0 group ${className}`}>
      <div className="relative">
        <img
          src={logoUrl}
          alt={logoAlt}
          className={`cursor-pointer object-contain transition-all duration-300 ${logoSizes} w-auto ${showHoverEffect ? 'group-hover:scale-105' : ''}`}
        />
        {showHoverEffect && (
          <div className="absolute -inset-2 bg-gradient-to-r from-transparent via-primary/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-full blur-md"></div>
        )}
      </div>
    </Link>
  );
};

Logo.propTypes = {
  logoUrl: PropTypes.string.isRequired,
  logoAlt: PropTypes.string,
  scrolled: PropTypes.bool,
  href: PropTypes.string,
  className: PropTypes.string,
  showHoverEffect: PropTypes.bool,
  customSizes: PropTypes.string
};

export default Logo;